const typographyModalAction = {
  text: 'ANEXAR ARQUIVOS',
  true: 'Cadastrar Nova Ação',
  false: 'Editar Ação'
};

export default typographyModalAction;
